import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import '../../buttons/BabyButton/Base.js';
import '../../buttons/BabyButton/variants/Chat/index.js';
import '../../buttons/BabyButton/variants/Menu/index.js';
import '../../buttons/BabyButton/variants/User/index.js';
import '../../buttons/BabyButton/variants/Vip/index.js';
import '../../buttons/BabyButton/variants/Wallet/index.js';
import '../../buttons/Button/index.js';
import { CloseButton } from '../../buttons/CloseButton/index.js';
import '../../buttons/DirectionButton/index.js';
import '../../buttons/GradientButton/index.js';
import '../../buttons/GradientButtonV2/index.js';
import '../../buttons/TabButton/index.js';
import '../../buttons/TabButtonV2/index.js';
import '../../buttons/TimerButton/index.js';
import '../../buttons/TimerButtonV2/index.js';
import '../../buttons/TimerButtonV3/index.js';
import cx from 'classnames';
import { ModalContentWrapper } from './ModalContentWrapper/index.js';
import { usePullDownToClose } from './utils/usePullDownToClose.js';
import s from './Modal.module.scss.js';

ReactModal.setAppElement("body");
const defaultStyles = {
  overlay: {
    background: "#00000080",
    zIndex: 9999,
    left: "0",
    top: "0",
    width: "100%",
    height: "100%"
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "visible",
    width: "320px",
    maxWidth: 974,
    maxHeight: "90%",
    height: "100%",
    border: 0,
    padding: "32px",
    borderRadius: "10px",
    background: "linear-gradient(180deg, #122227 -66.87%, #081519 50%)",
    boxShadow: "rgb(0, 0, 0) 0px 20px 40px 0px"
  },
  close: {}
};
const Modal = ({
  modalIsOpen,
  closeModal,
  afterOpenModal,
  onAfterClose,
  contentLabel,
  hideCloseButton,
  children,
  configuration,
  bottom,
  title,
  wrapperBorderless,
  withWrapper,
  mobileWrapperV2,
  forceDisableScroll,
  autoHeight,
  parentSelector,
  onNavBack,
  header,
  portalClassName = "",
  hideCloseButtonMobile,
  mobileWrapperV2BodyScrollable,
  contentRef = null,
  blockPageScroll = true,
  overlayTransparent = false
}) => {
  const [styles, setStyles] = useState({
    overlay: {
      ...defaultStyles.overlay,
      position: parentSelector ? "absolute" : "fixed",
      ...configuration?.overlay
    },
    content: {
      ...defaultStyles.content,
      ...configuration?.content
    },
    close: {
      ...defaultStyles.close,
      ...configuration?.close
    }
  });
  const { isMobile } = useWindowSize();
  usePullDownToClose({
    enabled: !!bottom,
    setShowModal: closeModal,
    showModal: modalIsOpen
  });
  useEffect(() => {
    setStyles({
      overlay: {
        ...defaultStyles.overlay,
        position: parentSelector ? "absolute" : "fixed",
        ...configuration?.overlay,
        background: bottom && isMobile ? "transparent" : configuration?.overlay?.background || defaultStyles.overlay.background
      },
      content: {
        ...defaultStyles.content,
        ...configuration?.content
      },
      close: {
        ...defaultStyles.close,
        ...configuration?.close
      }
    });
  }, [bottom, isMobile, configuration, parentSelector]);
  return /* @__PURE__ */ React.createElement(
    ReactModal,
    {
      parentSelector,
      closeTimeoutMS: 300,
      isOpen: modalIsOpen,
      onRequestClose: closeModal,
      onAfterOpen: () => {
        if (forceDisableScroll) {
          document.documentElement?.classList.add("modal-fix-scroll");
        }
        if (blockPageScroll) {
          setTimeout(() => {
            window.document.body?.classList.add("modal-body-block-scroll");
          }, 50);
        }
        afterOpenModal?.();
      },
      onAfterClose: () => {
        if (forceDisableScroll) {
          document.documentElement?.classList.remove("modal-fix-scroll");
        }
        window.document.body?.classList.remove("modal-body-block-scroll");
        onAfterClose?.();
        closeModal();
      },
      style: {
        ...styles
      },
      portalClassName: `ReactModalPortal ${portalClassName}`,
      contentLabel,
      overlayClassName: `${overlayTransparent ? "overlay-hide" : ""} ${bottom ? "bottom" : ""} ${autoHeight ? "modal--autoheight" : ""}`
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(s.content),
        style: {
          ...configuration?.childrenWrapper
        },
        "data-modal-content": true,
        ref: contentRef
      },
      withWrapper && /* @__PURE__ */ React.createElement(
        ModalContentWrapper,
        {
          mobileWrapperV2BodyScrollable,
          onNavBack,
          borderless: wrapperBorderless,
          title,
          onClose: closeModal,
          mobileWrapperV2,
          header,
          "data-modal-content-wrapper": true,
          hideCloseButtonMobile,
          style: {
            ...configuration?.contentWrapper
          }
        },
        children
      ),
      !withWrapper && /* @__PURE__ */ React.createElement(React.Fragment, null, !hideCloseButton && /* @__PURE__ */ React.createElement(CloseButton, { onClick: () => closeModal() }), children)
    )
  );
};
Modal.displayName = "ModalComponent.Modal";

export { Modal };
//# sourceMappingURL=Modal.js.map
